import "~/controllers"
import "@hotwired/turbo-rails"

document.addEventListener("turbo:load", () => {
  import("~/lib/public_analytics").then(({ loadPublicAnalytics }) => loadPublicAnalytics())

  const blocks = document.querySelectorAll(".article-reading-body pre code:not(.hljs)")
  if (blocks.length) import("highlight.js/lib/common").then(({ default: hljs }) => blocks.forEach((block) => hljs.highlightElement(block)))
})
